'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, useState, Dispatch, SetStateAction } from 'react';
import { useGivenAnswers } from './legalFormHooks';
type QuestionIndex = {
  index: number;
  cause: 'initial' | 'answer' | 'edit' | 'reset';
};
type QuestionIndexContextType = [QuestionIndex, Dispatch<SetStateAction<QuestionIndex>>];
export const QuestionIndexContext = createContext<QuestionIndexContextType | undefined>(undefined);
export function useQuestionIndexContext() {
  const context = useContext(QuestionIndexContext);
  if (context === undefined) {
    throw new Error("useQuestionIndexContext must be used within a QuestionIndexContext.Provider");
  }
  return context;
}
export function QuestionIndexProvider(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const givenAnswers = useGivenAnswers();
  const newIndex = [...givenAnswers.values()].findIndex(_temp);
  let t1;
  if ($[0] !== newIndex) {
    t1 = {
      index: newIndex,
      cause: "initial"
    };
    $[0] = newIndex;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const state = useState(t1);
  let t2;
  if ($[2] !== children || $[3] !== state) {
    t2 = <QuestionIndexContext.Provider value={state}>{children}</QuestionIndexContext.Provider>;
    $[2] = children;
    $[3] = state;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp(v) {
  return v === null;
}